import React from "react";

export default function ViewIconCellRenderer({ value }) {
  const iconimg = value ? "icons/vwicn" + ("000" + value).slice(-3) + ".gif" : "";

  const icon = value ? (
    <span>
      <img alt={value} border="0" width="12" height="12" src={iconimg} />
    </span>
  ) : null;

  return icon;
}
